var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelparrow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.91,
    height: 7.247,
    viewBox: "0 0 12.91 7.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27793",
    "data-name": "Group 27793",
    transform: "translate(-24 -26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download_12_",
    "data-name": "download (12)",
    transform: "translate(24 33.247) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32011",
    "data-name": "Path 32011",
    d: "M7.015,7.035,1.372,12.678a.817.817,0,0,1-1.14,0,.817.817,0,0,1,0-1.14L5.315,6.455.232,1.372a.817.817,0,0,1,0-1.14.817.817,0,0,1,1.14,0L7.015,5.895A.817.817,0,0,1,7.015,7.035Z",
    fill: "#208ce1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelparrow2);
export default __webpack_public_path__ + "static/media/helparrow2.93d780399265b3c99409b01adbf5306e.svg";
export { ForwardRef as ReactComponent };